import { Play } from "lucide-react";
import { Button } from "@/components/ui/primitives";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

export function OutcomeCard({
  tone = "success",
  title,
  children,
  primaryLabel,
  onPrimary,
  primaryDisabled,
  secondaryLabel,
  onSecondary,
}: {
  tone?: "success" | "warn" | "destructive" | "brand";
  title: string;
  children: ReactNode;
  primaryLabel?: string;
  onPrimary?: () => void;
  primaryDisabled?: boolean;
  secondaryLabel?: string;
  onSecondary?: () => void;
}) {
  const toneBorder = {
    success: "border-success/30 bg-success/5",
    warn: "border-warn/30 bg-warn/5",
    destructive: "border-destructive/30 bg-destructive/5",
    brand: "border-brand/30 bg-brand/5",
  }[tone];
  const toneTitle = {
    success: "text-success",
    warn: "text-warn",
    destructive: "text-destructive",
    brand: "text-brand",
  }[tone];
  return (
    <aside className={cn("rounded-xl border p-5 sticky top-8", toneBorder)}>
      <h3 className={cn("text-sm font-semibold", toneTitle)}>{title}</h3>
      <div className="mt-3 space-y-2 text-sm text-foreground">{children}</div>
      {(primaryLabel || secondaryLabel) && (
        <div className="mt-5 space-y-2">
          {primaryLabel && (
            <Button className="w-full" variant={tone === "brand" ? "brand" : "primary"} onClick={onPrimary} disabled={primaryDisabled}>
              {primaryLabel}
            </Button>
          )}
          {secondaryLabel && (
            <Button className="w-full" variant="outline" onClick={onSecondary}>
              <Play className="h-3.5 w-3.5" strokeWidth={2.2} />
              {secondaryLabel}
            </Button>
          )}
        </div>
      )}
    </aside>
  );
}
